import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Simple flat structure
const resources = {
  en: {
    translation: {
      "Tell us about yourself": "Tell us about yourself",
      "Your Business Name": "Your Business Name",
      // ... add all your translations
    },
  },
};

// Don't initialize immediately
export const initI18n = () => {
  return i18n.use(initReactI18next).init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
};

export default i18n;
